import { useMemo } from 'react';
import { CircleDot } from 'lucide-react';
import { FilterBar } from '@/components/filters/FilterBar';
import {
  FILTER_ALL_VALUE,
  type FilterDefinition,
  type FilterOption,
} from '@/components/filters/filter-types';
import type { BlueprintFiltersResult } from '@/hooks/blueprints/useBlueprintFilters';

const ALL_VALUE = FILTER_ALL_VALUE;

const STATUS_OPTIONS: FilterOption[] = [
  { value: 'building', label: 'Building' },
  { value: 'ready', label: 'Ready' },
  { value: 'failed', label: 'Failed' },
];

interface BlueprintFilterBarProps {
  filtersResult: BlueprintFiltersResult;
  className?: string;
}

export function BlueprintFilterBar({ filtersResult, className }: BlueprintFilterBarProps) {
  const { filters, setStatus } = filtersResult;

  const filterDefinitions = useMemo<FilterDefinition[]>(
    () => [
      {
        id: 'status',
        label: 'Status',
        icon: CircleDot,
        value: filters.status ?? ALL_VALUE,
        options: STATUS_OPTIONS,
        onValueChange: (v) =>
          setStatus(v === ALL_VALUE ? null : (v as 'building' | 'ready' | 'failed')),
        searchPlaceholder: 'Search statuses…',
      },
    ],
    [filters.status, setStatus],
  );

  return <FilterBar filters={filterDefinitions} className={className} />;
}
